<template>
  <b-card class="rounded">
    <b-form @submit="onSubmit">
      <b-row class="mb-2">
        <b-col class="col-3">
          <b-input-group size="sm">
            <template #append>
              <b-input-group-text>
                <i
                  class="hp-text-color-blue-100 hp-text-color-dark-0 ri-search-line"
                  style="font-size: 16px"
                ></i>
              </b-input-group-text>
            </template>
            <b-form-input
              id="filter-input"
              v-model="filter_text"
              type="search"
              placeholder="Поиск по таблице"
            ></b-form-input>
          </b-input-group>
        </b-col>

        <b-col>
          <b-row class="align-items-center mb-3 float-right">
            <span class="hp-placeholder mr-2 float-right">Фильтры</span>
            <b-form-select
              v-model="status_filter"
              size="sm"
              class="col-8 float-right"
              placeholder="Статус"
            >
              <b-form-select-option :value="null"> --- </b-form-select-option>
              <b-form-select-option value="active"
                >Активный</b-form-select-option
              >
              <b-form-select-option value="banned">
                Заблокированный
              </b-form-select-option>
              <b-form-select-option value="not_active">
                Не активный
              </b-form-select-option>
            </b-form-select>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-table
          class="align-items-center"
          id="my-table"
          responsive
          :striped="false"
          :sticky-header="true"
          style="min-height: 40vh; max-height: 58vh"
          :no-border-collapse="true"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :items="items"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          ref="selectableTable"
          selectable
          @row-selected="onRowSelected"
        >
          <template #head(username)>
            <div class="text-nowrap">Имя</div>
          </template>
          <template #head(org_name)>
            <div class="text-nowrap">Компания</div>
          </template>
          <template #head(inn)>
            <div class="text-nowrap">ИНН</div>
          </template>
          <template #head(status)>
            <div class="text-nowrap">Статус</div>
          </template>
          <template #head(actions)>
            <div class="text-nowrap"></div>
          </template>

          <template #cell(status)="row">
            <b-button
              v-if="row.item.status == 'banned'"
              size="sm"
              variant="danger"
              class="btn-ghost"
              disabled
              >Заблокированный</b-button
            >
            <b-dropdown
              v-else
              class="position-static"
              block
              size="sm"
              id="dropdown-1"
              :variant="row.item.status == 'not_active' ? 'dark' : 'success'"
              no-caret
            >
              <template v-if="row.item.status == 'not_active'" #button-content>
                Не активный
              </template>
              <template v-else #button-content>
                Активный
              </template>
              <b-dropdown-item-button
                @click="activate(row.item)"
                >Активировать</b-dropdown-item-button
              >
              <b-dropdown-item-button @click="deactivate(row.item)"
                >Дезактивировать</b-dropdown-item-button
              >
            </b-dropdown>
          </template>

          <template #cell(actions)="row">
            <b-dropdown
              class="position-static"
              block
              size="sm"
              id="dropdown-1"
              variant="link"
              no-caret
            >
              <template #button-content>
                <i
                  class="hp-text-color-blue-100 hp-text-color-dark-0 ri-more-2-fill"
                  style="font-size: 16px"
                ></i>
              </template>
              <b-dropdown-item-button @click="goProfile(row.item)"
                >Профиль</b-dropdown-item-button
              >
              <b-dropdown-item-button
                v-if="row.item.status != 'banned'"
                @click="banUser(row.item)"
                >Заблокировать</b-dropdown-item-button
              >
              <b-dropdown-item-button v-else @click="unbanUser(row.item)"
                >Разблокировать</b-dropdown-item-button
              >
              <b-dropdown-item-button @click="deleteModalItem = row.item"  v-b-modal.modal-1
                >Удалить</b-dropdown-item-button
              >
            </b-dropdown>
          </template>
        </b-table>
      </b-row>

      <b-row>
        <b-col>
          <b-row class="align-items-center ml-0">
            <span class="hp-placeholder mr-2">Строк на страницу</span>
            <b-form-select size="sm" class="col-3 float-left" v-model="perPage">
              <b-form-select-option :value="10">10</b-form-select-option>
              <b-form-select-option :value="50">50</b-form-select-option>
              <b-form-select-option :value="100">100</b-form-select-option>
              <b-form-select-option :value="200">200</b-form-select-option>
            </b-form-select>
          </b-row>
        </b-col>
        <b-col
          ><b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            size="sm"
          ></b-pagination
        ></b-col>
      </b-row>
    </b-form>

    <b-modal
      :id="`modal-1`"
      hide-footer
      header-class="align-items-center pt-reduced pb-reduced"
    >
      <template #modal-header="{ close }">
        <h5 class="mb-0">Удалить пользователя?</h5>

        <b-button
          variant="text"
          @click="close()"
          class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
          style="min-height: 24px"
        >
          <i
            class="ri-close-line hp-text-color-dark-0 lh-1"
            style="font-size: 24px"
          ></i>
        </b-button>
      </template>
      <b-form class="col-12">
        <b-form-row>
          <p>
            Вы уверены, что хотите удалить пользователя
            <span class="font-weight-bold">{{ deleteModalItem.username }}</span>
            без возможности отменить это действие?
          </p>
        </b-form-row>
        <b-form-row class="mt-5">
          <b-col
            ><b-button
              class="col-12"
              variant="outline-primary"
              @click="$bvModal.hide('modal-1')"
            >
              Отмена
            </b-button></b-col
          >
          <b-col
            ><b-button
              class="col-12"
              variant="danger"
              @click="delUser(deleteModalItem); $bvModal.hide('modal-1')"
            >
              Удалить
            </b-button></b-col
          >
        </b-form-row>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCol,
  BRow,
  BTable,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckbox,
  BFormSelect,
  BFormSelectOption,
  BInputGroup,
  BButton,
  BFormInput,
  BInputGroupText,
  BInputGroupAppend,
  BFormDatepicker,
  BFormRow,
  BPagination,
  BDropdown,
  BDropdownItemButton,
  BDropdownForm,
  BCard,
  BModal,
  BForm,
} from "bootstrap-vue";

import axios from "axios";

export default {
  data() {
    return {
      fields: [""],
      items: [""],
      striped: true,
      bordered: true,
      borderless: false,
      outlined: true,
      small: true,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: "",
      filter_text: "",
      status_filter: null,
      currentPage: 1,
      perPage: 10,
      rows: 0,
      selected: [],
      sortBy: "id",
      sortDesc: false,

      deleteModalItem: {
        username: ""
      },
    };
  },
  components: {
    BCol,
    BRow,
    BTable,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckbox,
    BFormSelect,
    BFormSelectOption,
    BInputGroup,
    BInputGroupText,
    BButton,
    BFormInput,
    BInputGroupAppend,
    BFormDatepicker,
    BFormRow,
    BPagination,
    BDropdown,
    BDropdownItemButton,
    BDropdownForm,
    BCard,
    BModal,
    BForm,
  },
  mounted() {
    this.updateTable();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.updateTable();
    },
    updateTable() {
      var vm = this;
      axios
        .get(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients`,
          {
            params: {
              text: this.filter_text,
              status_filter: this.status_filter,
            },
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          vm.fields = [
            { key: "username", sortable: true },
            { key: "email", sortable: true },
            { key: "org_name", sortable: true },
            { key: "inn", sortable: true },
            { key: "status", sortable: true },
          ];
          if (vm.$store.state.user['role'] == 'admin') {
            vm.fields.push({ key: "actions", sortable: false });
          }
          vm.items = response.data.items;
          vm.rows = vm.items.length;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onRowSelected(items) {
      this.selected = items;
      this.$router.push({
        name: "client-manager",
        params: { inn: items[0].inn, card: "profile" },
      });
    },
    goProfile(item) {
      this.$router.push({
        name: "client-manager",
        params: { inn: item.inn, card: "profile" },
      });
    },
    async banUser(item) {
      await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/update/${item.inn}`,
        {
          status: "banned",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.updateTable();
    },
    async unbanUser(item) {
      await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/update/${item.inn}`,
        {
          status: "not_active",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.updateTable();
    },
    async delUser(item) {
      await axios.delete(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/delete/${item.inn}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.updateTable();
    },
    async activate(item) {
      await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/activate/${item.inn}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.updateTable();
    },
    async deactivate(item) {
      await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/deactivate/${item.inn}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.updateTable();
    }
  },
};
</script>
